import BookStep1 from "components/view/book/step1";
import { useMutation } from "@tanstack/react-query";
import { searchRmApi } from "components/api/book";
import { useEffect, useState } from "react";
import { alertControl } from "util/commAction";
import { IRm } from "interface/book";
import { getDatesRange } from "components/calendar/action";
import { useBookInfContext } from "components/context/bookInfContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function BookStep1Page() {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const { bkStep, bookInf, onBookInf, isSearch, setIsSearch } =
    useBookInfContext();

  const { state } = useLocation();

  // const { lodInf } = useAuthContext();
  const { lodNo } = useParams();

  const [rmList, setRmList] = useState<IRm[] | null>(null);
  // 객실조회
  const rmListMutaition = useMutation({
    mutationFn: searchRmApi,
    onSuccess: (res) => {
      if (res) {
        const { status, data } = res;
        if (status.code === 0) {
          setRmList(data.rmList);
          setIsSearch(false);
        }
        if (status.code !== 0) {
          alertControl({
            isOpen: true,
            inner: status.message,
            click: () => {
              navigate("/" + lodNo);
            },
          });
        }
      }
    },
  });

  // useEffect(() => {}, []);

  useEffect(() => {
    if (!state || bookInf?.dates.length === 0) {
      setTimeout(() => {
        alertControl({
          isOpen: true,
          inner: t("alr_no_date"),
          click: () => {
            if (lodNo) {
              navigate("/" + lodNo);
            }
            if (!lodNo) {
              navigate("/");
            }
          },
        });
        return;
      }, 100);

      return;
    }
    if (state) {
      const { dates, lodNo, promCd, dateRange } = bookInf;

      onBookInf({
        promCd,
        lodNo,
        dates,
        dateRange,
      });
      let range = getDatesRange({
        startDateStr: dates[0],
        endDateStr: dates[1],
        direction: "down",
      });
      // setDateRange(range ?? []);
      setIsSearch(true);
    }
  }, [state]);

  useEffect(() => {
    if (isSearch && bkStep === 1) {
      const { adltCnt, childCnt, rmCnt, lodNo, dates } = bookInf;
      const params = {
        adltPerCt: adltCnt,
        chldPerCt: childCnt ?? 0,
        lodChlCd: "",
        lodNo,
        resvEDt: dates[1],
        resvSDt: dates[0],
        resvRmCt: rmCnt,
      };

      //

      if (params) {
        rmListMutaition.mutate(params);
      }
    }
  }, [isSearch]);

  return <BookStep1 rmList={rmList} isLoading={rmListMutaition.isLoading} />;
}
